module.exports = __webpack_public_path__ + "img/mail.331781e1.png";